function Collection(container) {
  var sectionId = container.getAttribute('data-section-id');
  var Carousel = document.getElementById('glider-carousel-' + sectionId);
  if (Carousel) {
    Sliders(container);
  }
}

sectionEvents.forEach(function(sectionEvent){
  let sectionContainer = sectionEvent.detail;
  let sectionType = sectionContainer.dataset.sectionType;
  Collection(sectionContainer);
})

theme.Collection = (function() {
  function Collection(container) {
    var sectionId = container.getAttribute('data-section-id'),
        l = container.getAttribute('data-layout'),
        aB = document.getElementById('ajaxBusy'),
        cG = document.querySelector('#collection-grid');
    var ajaxLoadPage = function (url) {
      aB.style.display = 'block';
      fetch(url)
      .then(response => response.text())
      .then(data => {
        var c = document.getElementById('collection-products'),
            p = document.getElementById('paginateBy'),
            bC = document.querySelector('.breadcrumbs'),
            f = document.getElementById('filters');
        const parser = new DOMParser();
        const htmlDocument = parser.parseFromString(data, 'text/html');
        var nC = htmlDocument.documentElement.querySelector('#collection-products'),
            nP = htmlDocument.documentElement.querySelector('#paginateBy'),
            nBC = htmlDocument.documentElement.querySelector('.breadcrumbs'),
            nF = htmlDocument.documentElement.querySelector('#filters');
        if (c) {
          c.replaceWith(nC);
        }
        if (p) {
          p.replaceWith(nP);
        }
        if (bC) {
          bC.replaceWith(nBC);
        }
        if (f) {
          f.replaceWith(nF);
        }
        Wrap();
        filters.action();
        if (l == 'form') {
          Order(container);
        } else {
          if (theme.settings.quickView) {
            Quick();
          };
          if (theme.settings.compare) {
            CompareProducts();
          };
        }
        PriceChange();
        Swatches(container);
        if (theme.settings.cart) {
          Cart(container);
        }
        history.replaceState({
          page: url
        }, url, url);
        theme.Pagination.enable(container);
        LoadMore.init(container);
        var s = cG.getBoundingClientRect().top + window.pageYOffset;
        window.setTimeout(function() {
          window.scrollTo({top:s - document.selectors.sht, behavior: 'smooth'});
        }, 0);
        aB.style.display = 'none';
      }).catch(function (err) {
        console.log('!: ' + err);
      });
    };
    var filters = {
      action:function (e) {
        var pA = container.querySelectorAll('.paginateBy'),
            sB = container.querySelector('select.sortBy');
        pA.forEach(function(p) {
          p.onclick = function(ev){
            var u = new URL(window.location),
                params = u.searchParams;
            u.search = params.toString();
            var url = u.toString(),
                pag = this.textContent;
            aB.style.display = 'block';
            fetch(theme.routes_cart_url + '.js', {
              method: 'POST',
              headers: {
                'Content-Type': 'application/json'
              },
              body: JSON.stringify({attributes: {'pagination': pag }})
            }).then(function () {
              ajaxLoadPage(url);
            });
          }
        });
        var fA = container.querySelectorAll('.advanced-filter a');
        fA.forEach(function(f) {
          f.onclick = function(ev){
            ev.preventDefault();
            var url = f.getAttribute('href');
            ajaxLoadPage(url);
          }
          f.onmouseenter = function(){
            f.classList.add('hover');
          };
          f.onmouseleave = function(){
            f.classList.remove('hover');
          };
        });
        var dS = container.querySelectorAll('.dropdown select');
        dS.forEach(function(d) {
          d.onchange = function(){
            if (d.value) {
              location.href = d.value;
            }
            else {
              location.href = theme.routes_all_products_collection_url;
            }
          };
        });
        if (sB) {
          sB.onchange = function(s){
            var u = new URL(window.location),
                params = u.searchParams;
            params.set('sort_by', this.value);
            u.search = params.toString();
            var url = u.toString();
            ajaxLoadPage(url);
          };
        };
        var iW = theme.width,
            sD = document.querySelector('#sorting details'),
            dO = document.querySelectorAll('.open-container-filter.desktop > details');
        if (iW <= theme.breakpoint_margin) {
          if (sD) {
            sD.open = false;
          }
          dO.forEach(function(d) {
            d.addEventListener('toggle', function() {
              if (!this.open) this.open = true;
            });
          });
        }
      }
    };
    function PriceChange() {
      var mnV = document.getElementById('price-min'),
          mxV = document.getElementById('price-max'),
          pIN = container.querySelectorAll('.price-input[type="number"]'),
          pIR = container.querySelectorAll('.price-input[type="range"]');
      function PriceChangeType() {
        var u = new URL(window.location),
            paramsN = u.searchParams,
            paramsX = u.searchParams;
        paramsN.set(mnV.getAttribute('data-url'), mnV.value);
        paramsX.set(mxV.getAttribute('data-url'), mxV.value);
        u.search = paramsN.toString();
        u.search = paramsX.toString();
        var url = u.toString();
        ajaxLoadPage(url);
      }
      pIN.forEach(function(p) {
        let timeout;
        p.addEventListener('keyup', function (e) {
          if (e.keyCode != 9) {
            clearTimeout(timeout);
            timeout = setTimeout(function () {
              PriceChangeType();
            }, 750);
          }
        });
      });
      pIR.forEach(function(p) {
        p.addEventListener('change', PriceChangeType);
      });
    };

    // --- Experimental Load More (collection page, grid layout only) --------
    // Opt-in via section setting `enable_load_more_test` (data-load-more-enabled
    // on the section container; only rendered when layout is "grid" since the
    // "row"/"form" layouts use different card markup - collection.row.liquid /
    // collection.orderForm.liquid - and aren't covered here). Same rationale as
    // the search-page version: chains page fetches automatically whenever a
    // fetched page has zero visible `.search-result` cards, so the customer
    // never lands on a sparse or blank page. Unlike the search page's markup,
    // #collection-products *is* the product grid itself (not a wrapper around
    // it), so new cards are inserted directly into it, ahead of the pagination
    // control rather than as a new sibling grid.
    var LoadMore = {
      MAX_EMPTY_CHAIN: 20,
      init: function (root) {
        var wrap = root.querySelector('[data-load-more]');
        if (!wrap || root.getAttribute('data-load-more-enabled') !== 'true') {
          return;
        }
        var nativePagination = root.querySelector('[data-native-pagination]');
        if (nativePagination) {
          nativePagination.hidden = true;
        }
        wrap.hidden = false;
        this.bind(wrap);
        // A collection can be almost entirely `similar_product_hide`/
        // unavailable products with the few real ones clustered many raw
        // pages in - the very first server-rendered page can come back with
        // zero visible cards. Waiting for the customer to scroll the (empty)
        // control into view, or to notice and click it, isn't good enough;
        // start the catch-up chain immediately. Hide the button while it
        // runs (nothing useful to click mid-chain) and show the standalone
        // spinner in its place - see setLoading().
        var grid = wrap.parentNode,
            nextUrl = wrap.getAttribute('data-next-url');
        if (!grid.querySelector('.search-result') && nextUrl) {
          var btn = wrap.querySelector('[data-load-more-btn]');
          if (btn) {
            btn.hidden = true;
          }
          this.run(wrap, nextUrl, 0);
        }
      },
      bind: function (wrap) {
        var btn = wrap.querySelector('[data-load-more-btn]');
        if (btn && !btn._loadMoreBound) {
          btn._loadMoreBound = true;
          btn.addEventListener('click', function (ev) {
            ev.preventDefault();
            if (wrap.getAttribute('data-loading') === 'true') {
              return;
            }
            LoadMore.run(wrap, wrap.getAttribute('data-next-url'), 0);
          });
        }
        this.observe(wrap);
      },
      // Infinite scroll: auto-fetch once the control comes within ~600px of the
      // viewport, so the customer never has to click. The button stays in the
      // markup (and its click handler above stays bound) as a keyboard/no-JS
      // fallback - it's just pre-empted by this in the common scroll case.
      observe: function (wrap) {
        if (wrap._loadMoreObserver || !('IntersectionObserver' in window)) {
          return;
        }
        var observer = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (!entry.isIntersecting || wrap.hidden || wrap.getAttribute('data-loading') === 'true') {
              return;
            }
            var url = wrap.getAttribute('data-next-url');
            if (url) {
              LoadMore.run(wrap, url, 0);
            }
          });
        }, { rootMargin: '0px 0px 600px 0px' });
        observer.observe(wrap);
        wrap._loadMoreObserver = observer;
      },
      setStatus: function (wrap, text) {
        var status = wrap.querySelector('[data-load-more-status]');
        if (status) {
          status.textContent = text || '';
        }
      },
      setLoading: function (wrap, isLoading) {
        var btn = wrap.querySelector('[data-load-more-btn]'),
            spinner = wrap.querySelector('.load-more-spinner'),
            standaloneSpinner = wrap.querySelector('[data-load-more-standalone-spinner]'),
            btnHidden = !btn || btn.hidden;
        wrap.setAttribute('data-loading', isLoading ? 'true' : 'false');
        if (btn) {
          btn.setAttribute('aria-disabled', isLoading ? 'true' : 'false');
        }
        if (spinner) {
          spinner.hidden = !isLoading || btnHidden;
        }
        if (standaloneSpinner) {
          standaloneSpinner.hidden = !isLoading || !btnHidden;
        }
      },
      run: function (wrap, url, depth) {
        if (!url) {
          return;
        }
        if (depth === 0) {
          this.setLoading(wrap, true);
          this.setStatus(wrap, wrap.getAttribute('data-label-loading'));
        }
        if (depth > this.MAX_EMPTY_CHAIN) {
          this.setLoading(wrap, false);
          this.setStatus(wrap, wrap.getAttribute('data-label-error'));
          wrap.hidden = true;
          this.disconnect(wrap);
          return;
        }
        var self = this;
        fetch(url)
          .then(function (response) {
            if (!response.ok) {
              throw new Error('Load more request failed: ' + response.status);
            }
            return response.text();
          })
          .then(function (html) {
            var doc = new DOMParser().parseFromString(html, 'text/html'),
                newRoot = doc.querySelector('#collection-products'),
                newCards = newRoot ? newRoot.querySelectorAll('.search-result') : [],
                newControl = doc.querySelector('[data-load-more]'),
                nextUrl = newControl ? newControl.getAttribute('data-next-url') : '',
                btn = wrap.querySelector('[data-load-more-btn]');
            if (newCards.length) {
              // Real content found - if the button was hidden for a silent
              // empty-page catch-up (see init()), restore it now so normal
              // click/scroll interaction resumes for whatever comes next.
              if (btn) {
                btn.hidden = false;
              }
              var frag = document.createDocumentFragment();
              newCards.forEach(function (card) {
                card.querySelectorAll('img[loading="eager"]').forEach(function (img) {
                  img.loading = 'lazy';
                });
                frag.appendChild(card);
              });
              wrap.parentNode.insertBefore(frag, wrap);
              if (theme.settings.quickView) {
                Quick();
              }
              if (theme.settings.compare) {
                CompareProducts();
              }
              Swatches(container);
              if (theme.settings.cart) {
                Cart(container);
              }
            }
            wrap.setAttribute('data-next-url', nextUrl || '');
            if (btn) {
              btn.setAttribute('href', nextUrl || '#');
            }
            if (!newCards.length && nextUrl) {
              self.run(wrap, nextUrl, depth + 1);
              return;
            }
            self.setLoading(wrap, false);
            if (!nextUrl) {
              self.setStatus(wrap, wrap.getAttribute('data-label-done'));
              wrap.hidden = true;
              self.disconnect(wrap);
            } else {
              self.setStatus(wrap, '');
            }
          })
          .catch(function (err) {
            self.setLoading(wrap, false);
            self.setStatus(wrap, wrap.getAttribute('data-label-error'));
            console.log('!: ' + err);
          });
      },
      disconnect: function (wrap) {
        if (wrap._loadMoreObserver) {
          wrap._loadMoreObserver.disconnect();
          wrap._loadMoreObserver = null;
        }
      }
    };

    PriceChange();
    filters.action();
    Swatches(container);
    theme.Pagination.enable(container);
    LoadMore.init(container);
    if (theme.settings.cart) {
      Cart(container);
    }
    var popped = ('state' in window.history && window.history.state !== null);
    var initialURL = location.href;
    window.onpopstate = function (e) {
      var initialPop = !popped && location.href == initialURL;
      popped = true;
      if (initialPop) {
        return;
      }
    };
    Shopify.queryParams = {};
    if (location.search.length) {
      for (var aKeyValue, i = 0, aCouples = location.search.substr(1).split('&'); i < aCouples.length; i++) {
        aKeyValue = aCouples[i].split('=');
        if (aKeyValue.length > 1) {
          Shopify.queryParams[decodeURIComponent(aKeyValue[0])] = decodeURIComponent(aKeyValue[1]);
        }
      }
    }
    Collection.prototype.onSelect = function(ev) {
      var Carousel = document.getElementById('glider-carousel-' + sectionId);
      if (Carousel) {
        Sliders(container);
      }
      if (theme.settings.quickView) {
        Quick();
      };
      if (theme.settings.compare) {
        CompareProducts();
      };
      Wrap();
    }
  }
  return Collection;
})();